<template>
  <div class="quiz-info-section flex flex-col gap-5">
    <div class="flex justify-between gap-2 flex-wrap">
      <div class="flex gap-2">
        <TypeCorrectAnswer
          v-if="scoring"
          :type-answer-correct="scoring?.result"
        />
        <div
          class="quiz-order
          flex gap-1 justify-between items-center font-bold bg-primary-50 text-xs rounded px-2 py-1"
        >
          <aha-icon
            :name="icon"
            height="16"
            width="16"
            viewBox="0 0 30 30"
            maintain-color
          ></aha-icon>
          {{ slideName }}
        </div>
      </div>
      <div v-if="scoring" class="flex gap-2">
        <div class="flex justify-between items-center">
          <strong>{{ scoring?.time | MMmSSs }}</strong>&nbsp;{{ $i18nPresenter.t('time') }}
        </div>
        <span class="text-secondary-20">|</span>
        <div class="flex justify-between items-center">
          <strong>{{ scoring?.point || 0 | formatTotalPoint }}</strong>&nbsp;{{ $i18nPresenter.t('points') }}
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-4 md:flex-row md:justify-between">
      <div v-if="question?.title" class="quiz-title flex ">
        <span>{{ order }}.</span>
        <span>{{ question?.title }}</span>
      </div>
      <SquareThumbnail
        v-if="question?.image"
        :imageUrl="question?.image.thumbnail"
        class="img w-full md:w-36 md:max-h-36 rounded"
      >
      </SquareThumbnail>
    </div>
  </div>
</template>

<script>
import TypeCorrectAnswer from '@/components-v2/presentation-report/ReportAudienceDetail/TypeCorrectAnswer.vue'
import SquareThumbnail from '@/components-v2/presentation-report/ReportAudienceDetail/SquareThumbnail.vue'
import constants from '@/constant'

const icons = {
  [constants.SLIDE_TYPE.POLL]: 'multiple-choice',
  [constants.SLIDE_TYPE.OPEN_ENDED]: 'open-ended',
  [constants.SLIDE_TYPE.IDEAS]: 'brainstorm',
  [constants.SLIDE_TYPE.QUESTION]: 'qa',
  [constants.SLIDE_TYPE.WORD_CLOUD]: 'word-cloud',
  [constants.SLIDE_TYPE.SCALE]: 'scales',
  [constants.SLIDE_TYPE.CORRECT_ORDER]: 'correct-order',
  [constants.SLIDE_TYPE.MATCH_PAIRS]: 'match-pairs',
  [constants.SLIDE_TYPE.PICK_ANSWER]: 'pick-answer',
  [constants.SLIDE_TYPE.IMAGE_CHOICE]: 'pick-answer',
  [constants.SLIDE_TYPE.CATEGORISE]: 'categorise',
  [constants.INDIVIDUAL_REPORT_QUESTION_TYPE.WORD_CLOUD]: 'word-cloud',
  [constants.INDIVIDUAL_REPORT_QUESTION_TYPE.OPEN_ENDED]: 'open-ended',
  [constants.INDIVIDUAL_REPORT_QUESTION_TYPE.BRAIN_STORM]: 'brainstorm',
  [constants.INDIVIDUAL_REPORT_QUESTION_TYPE.SHORT_ANSWER]: 'mti-type-answer',

}

export default {
  components: {
    TypeCorrectAnswer,
    SquareThumbnail,

  },
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    scoring: {
      type: Object,
      default: () => {},
    },
    order: {
      type: Number,
      default: 1,
    },
    totalQuiz: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    icon() {
      return icons[this.question?.type] || 'multiple-choice'
    },
    slideName() {
      return this.question?.type
    },
  },

}
</script>

<style lang="scss" scoped>
.quiz-marker {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid var(--secondary-20, #D3D7E1);
  color: #313131;
  background: #FFF;
  transition: 0.2s all ease;

  @media screen and (min-width: 1280px) {
    &:hover, &:focus {
      color: #FFF;
      background: var(--primary-85, #4F9BF3);
    }
  }
}

.quiz-order {
  align-self: flex-start;
}

.quiz-title {
  position: relative;
  color: var(--base-90, #313131);
  font-size: 16px;
  font-weight: bold;
}

.quiz-info-wrapper {
  display: grid;
  gap:12px;
  grid-template-columns: 1fr auto;

  .quiz-image {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
}
</style>
